import { useTheme } from "@mui/material/styles";

import { themeMode } from "../../providers/theme/MuiThemeProvider";

const SystemSettingsMenuIconFilled = (): JSX.Element => {
  const theme = useTheme();

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill={theme.palette.primary.main} />
      <circle
        cx="16"
        cy="16"
        r="2.5"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
      />
      <path
        d="M17.471 7.79362C17.1648 7.66675 16.7765 7.66675 15.9999 7.66675C15.2233 7.66675 14.8351 7.66675 14.5288 7.79362C14.1204 7.96277 13.7959 8.28723 13.6268 8.69561C13.5496 8.88203 13.5193 9.09883 13.5075 9.41507C13.4901 9.87982 13.2518 10.31 12.849 10.5425C12.4463 10.7751 11.9546 10.7664 11.5434 10.549C11.2636 10.4012 11.0608 10.3189 10.8607 10.2926C10.4225 10.2349 9.97924 10.3537 9.62855 10.6227C9.36554 10.8246 9.1714 11.1608 8.78311 11.8334C8.39483 12.5059 8.20069 12.8422 8.15741 13.1708C8.09972 13.6091 8.21848 14.0523 8.48757 14.403C8.61039 14.563 8.783 14.6976 9.05091 14.8659C9.44475 15.1134 9.69816 15.535 9.69813 16.0001C9.69811 16.4652 9.44471 16.8867 9.05091 17.1341C8.78296 17.3025 8.61032 17.437 8.48748 17.5971C8.21839 17.9478 8.09964 18.391 8.15733 18.8293C8.2006 19.158 8.39475 19.4942 8.78303 20.1667C9.17132 20.8393 9.36546 21.1755 9.62847 21.3774C9.97915 21.6464 10.4224 21.7652 10.8606 21.7075C11.0607 21.6812 11.2635 21.599 11.5433 21.4511C11.9545 21.2338 12.4462 21.2251 12.849 21.4576C13.2518 21.6902 13.4901 22.1204 13.5075 22.5851C13.5193 22.9014 13.5496 23.1181 13.6268 23.3046C13.7959 23.7129 14.1204 24.0374 14.5288 24.2065C14.8351 24.3334 15.2233 24.3334 15.9999 24.3334C16.7765 24.3334 17.1648 24.3334 17.471 24.2065C17.8794 24.0374 18.2039 23.7129 18.373 23.3046C18.4503 23.1181 18.4805 22.9013 18.4923 22.5851C18.5097 22.1203 18.748 21.6902 19.1507 21.4576C19.5535 21.225 20.0453 21.2337 20.4565 21.451C20.7362 21.5989 20.9391 21.6811 21.1391 21.7075C21.5774 21.7651 22.0206 21.6464 22.3713 21.3773C22.6343 21.1755 22.8284 20.8392 23.2167 20.1667C23.605 19.4942 23.7991 19.1579 23.8424 18.8292C23.9001 18.391 23.7813 17.9478 23.5123 17.5971C23.3894 17.437 23.2168 17.3024 22.9489 17.1341C22.555 16.8866 22.3017 16.4651 22.3017 16C22.3017 15.535 22.5551 15.1135 22.9489 14.8661C23.2168 14.6977 23.3895 14.5631 23.5123 14.403C23.7814 14.0524 23.9002 13.6091 23.8425 13.1709C23.7992 12.8422 23.6051 12.5059 23.2168 11.8334C22.8285 11.1609 22.6344 10.8246 22.3713 10.6228C22.0207 10.3537 21.5774 10.235 21.1392 10.2927C20.9392 10.319 20.7363 10.4012 20.4565 10.5491C20.0453 10.7664 19.5536 10.7751 19.1508 10.5425C18.748 10.31 18.5097 9.8798 18.4923 9.41503C18.4805 9.09881 18.4503 8.88202 18.373 8.69561C18.2039 8.28723 17.8794 7.96277 17.471 7.79362Z"
        stroke={
          theme.palette.mode === themeMode.light
            ? theme.palette.otherBackgroundLight.main
            : theme.palette.text.primary
        }
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default SystemSettingsMenuIconFilled;
